import "../../../assets/scss/login.scss";
import { useNavigate } from "react-router-dom";
import axiosService from "../../../core/services/axios-service";
import ToastService from "../../../core/services/toaster-service";
import localStorageService from "../../../core/services/local-storage-service";
import { messageEnum } from "../../../core/dictionary/global-enums";
import { ApiRoutes } from "../../../core/dictionary/api-url";
import { useState } from "react";

export default function BusinessLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await axiosService.post(ApiRoutes.LOGIN_BUSINESS, {
        email: form.email,
        password: form.password,
      });
      if (res.data.success) {
        // Save token if needed: localStorage.setItem("token", res.data.token);
        localStorageService.setToken(res.data.token);
        localStorageService.setRole(res.data.role);
        localStorageService.setUserDetails(res.data.data);
        ToastService.success(messageEnum.adminLoginSuccessfull);
        // Redirect to dashboard or another page
        setTimeout(() => {
          const organisationId = res?.data?.data?.adminBusinessUsers[0]?._id || '';
          const url = `/business/organizations/${organisationId}`;
          navigate(url);
        }, 800);
      } else {
        setError(res.data.message || "Login failed");
        ToastService.error(res.data.message || "Login failed");
      }
    } catch (err) {
      setError("Invalid credentials or server error");
      ToastService.error("Invalid credentials or server error");
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      {/* Left side */}
      <div className="login-left">
        <img
          src="https://res.cloudinary.com/dhhzpdckr/image/upload/v1758128880/rescuernlogo_dsi3mf.png"
          alt="Rescuern Logo"
          className="company-logo"
        />
        <h1>RESUSCITATION TRAINING THAT BUILDS CONFIDENCE.</h1>
        <p>Code Blue Readiness for Teams That Save Lives.</p>
      </div>

      {/* Right side */}
      <div className="login-right">
        <div className="login-card">
          <h2>Business Leadership Login</h2>
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label>Email</label>
              <input
                id="email"
                name="email"
                type="email"
                className="login-input"
                placeholder="name@example.com"
                autoComplete="email"
                required
                value={form.email}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                id="password"
                name="password"
                type="password"
                className="login-input"
                placeholder="Enter your password"
                autoComplete="current-password"
                required
                value={form.password}
                onChange={handleChange}
              />
            </div>

            {error && <div className="text-danger mb-2">{error}</div>}
            <button type="submit" className="btn-login" disabled={loading}>
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
